import { render, staticRenderFns } from "./el-pagination.vue?vue&type=template&id=b3acf4d4&scoped=true"
import script from "./el-pagination.vue?vue&type=script&lang=js"
export * from "./el-pagination.vue?vue&type=script&lang=js"
import style0 from "./el-pagination.vue?vue&type=style&index=0&id=b3acf4d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3acf4d4",
  null
  
)

export default component.exports